import React from 'react';
import { NavLink as BaseNavLink, type To } from 'react-router-dom';

interface NavLinkAdapterProps {
	className?: string;
	activeClassName?: string;
	style?: React.CSSProperties;
	activeStyle?: React.CSSProperties;
	to: To;
}

const NavLinkAdapter = React.forwardRef<HTMLAnchorElement, NavLinkAdapterProps>(
	({ activeClassName, activeStyle, to, ...props }, ref) => {
		return (
			<BaseNavLink
				ref={ref}
				{...props}
				className={({ isActive }) =>
					[props.className, isActive ? activeClassName : null].filter(Boolean).join(' ')
				}
				style={({ isActive }) => ({
					...props.style,
					...(isActive ? activeStyle : null)
				})}
				to={to}
			/>
		);
	}
);

export default NavLinkAdapter;
